import MarqueeComponent from 'react-fast-marquee';
import styled from 'styled-components';

import { ReactComponent as Shape3 } from 'src/client/assets/images/galleryShapes/shape3.svg';

export const MarqueeContainer = styled(MarqueeComponent)`
  width: 100%;
  overflow: hidden;
`;

export const MarqueeChild = styled.div`
  margin-right: 30px;
  gap: 30px;
  display: inline-flex;
  align-items: center;
`;

export const SeparatorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ShapeSeparator = styled(Shape3)`
  width: 16px;
  height: 16px;
  fill: ${(props) => props.theme.colors.gray5};
`;
